import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Goods-index-1992f2b80c481975d-1'),
    routerUrl: '/Goods',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Goods')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Goods-index-1992f2b80c481975d-2'),
        routerUrl: '/GoodsForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./GoodsForm')),
      },
      //$MORE$
    ],
  },
];
